import { render, staticRenderFns } from "./NfBrand.vue?vue&type=template&id=56c7c306&scoped=true&"
import script from "./NfBrand.vue?vue&type=script&lang=js&"
export * from "./NfBrand.vue?vue&type=script&lang=js&"
import style0 from "./NfBrand.vue?vue&type=style&index=0&id=56c7c306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c7c306",
  null
  
)

export default component.exports